export enum DocumentActions {
  PRINT = 'print',
  DOWNLOAD = 'download',
  SHARE = 'share'
}
